import React, { useState } from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import { useSelector } from "react-redux";
import BizinBackend from "../../../../helpers/bizin_helper";
import useGetCsrfToken from "../../../../Hooks/useGetCsrfToken";

export default function GridBody({ rowData, onClose, onCancelSuccess }) {
  const { access_token, userProfile } = useSelector((state) => ({
    access_token: state.login.user?.access_token,
    userProfile: state.login.profile,
  }));
  const csrfToken = useGetCsrfToken();

  const [showSuccess, setShowSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [resultError, setResultError] = useState(false);
  const [resultMessage, setResultMessage] = useState("");
  const StatusAtual = rowData?.Ativo ?? rowData?.Status;
  const ID_Tabela_Frete = rowData?.ID_Tabela_Frete ?? rowData?.ID;
  const vaiAtivar = StatusAtual === "N";
  const novoStatus = vaiAtivar ? "S" : "N";

  const handleConfirm = async () => {
    setLoading(true);
    try {
      const resp = await BizinBackend.executeProcedure(
        { 1: Number(ID_Tabela_Frete), 2: novoStatus, 3: userProfile?.ID_Usuario },
        "FRONT_Workspace_DF_LO0020_Alterar_Status",
        csrfToken,
        access_token
      );
      const dados = Array.isArray(resp) ? resp[0] : resp?.resultset_1?.[0];

      if (dados?.Status === "OK") {
        setResultError(false);
        setResultMessage(dados.Mensagem);
        setShowSuccess(true);
      } else {
        setResultError(true);
        setResultMessage(dados?.Mensagem || "Erro ao alterar status.");
        setShowSuccess(true);
      }
    } catch (error) {
      console.error("Erro ao alterar status:", error);
      setResultError(true);
      setResultMessage("Erro ao alterar status. Tente novamente.");
      setShowSuccess(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseAll = () => {
    setShowSuccess(false);
    if (onCancelSuccess) onCancelSuccess();
    if (onClose) onClose();
  };
  if (showSuccess) {
    const isOk = !resultError;
    return (
      <Modal isOpen={true} toggle={handleCloseAll} centered className="modal-custom-style rounded">
        <ModalBody className="text-center p-5">
          <div className="mb-4 d-flex align-items-center justify-content-center">
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                width: "110px",
                height: "110px",
                backgroundColor: isOk ? "#4caf50" : "#EC221F",
                borderRadius: "50%",
              }}
            >
              <i
                className={isOk ? "fas fa-check text-white" : "fas fa-times text-white"}
                style={{ fontSize: "55px" }}
              ></i>
            </div>
          </div>
          <h2 className="font-w-600 text-color-azul1 mb-2" style={{ fontSize: "32px" }}>
            {isOk ? "Sucesso!" : "Não foi possível"}
          </h2>
          <p className="text-muted font-size-16 mb-4">
            {isOk
              ? vaiAtivar
                ? "A rota foi ativada com sucesso. A mesma pode ser desativada sempre que desejar através do mesmo painel."
                : "A rota foi desativada com sucesso. A mesma pode ser reativada sempre que desejar através do mesmo painel."
              : resultMessage}
          </p>
          <Button
            onClick={handleCloseAll}
            style={{ backgroundColor: "#2b3b6b", minWidth: "120px", height: "45px" }}
            className="border-0 font-w-600 text-white rounded font-size-16"
          >
            Ok!
          </Button>
        </ModalBody>
      </Modal>
    );
  }
  return (
    <Modal isOpen={true} toggle={onClose} centered className="modal-custom-style rounded">
      <ModalBody className="text-center p-5">
        <div className="mb-4 d-flex align-items-center justify-content-center">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ width: "110px", height: "110px", backgroundColor: "#ffb300", borderRadius: "50%" }}
          >
            <i className="fas fa-exclamation-triangle text-white" style={{ fontSize: "50px" }}></i>
          </div>
        </div>
        <h3 className="font-w-600 text-color-azul1 mb-3" style={{ fontSize: "26px" }}>
          {vaiAtivar ? "Tem certeza que deseja ativar a rota?" : "Tem certeza que deseja desativar a rota?"}
        </h3>
        <p className="text-muted font-size-15 mb-4 px-3">
          {vaiAtivar
            ? "Ao confirmar, rota selecionada será ativada imediatamente."
            : "Ao confirmar, rota selecionada será desativada imediatamente."}
        </p>
        <div className="d-flex justify-content-center gap-3">
          <Button
            onClick={onClose}
            color="light"
            className="font-w-600 text-color-azul1 border bg-white rounded"
            style={{ height: "42px", minWidth: "120px" }}
            disabled={loading}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleConfirm}
            className="border-0 font-w-600 text-white rounded"
            style={{ backgroundColor: "#2b3b6b", height: "42px", minWidth: "120px" }}
            disabled={loading}
          >
            {loading ? "Aguardando..." : "Confirmar"}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}